import React, {useState, useEffect, forwardRef, useImperativeHandle} from 'react';
import {Table, Avatar, Button, Input, Tag, PageHeader, message} from 'antd';
import {getFollowInfos, getAllFollowInfos} from '@/api/followInfo';
import _ from 'lodash';

const CustomerTable = forwardRef(({extId, onJob = true, selectGive, selectGives = []}, ref) => {
    const [current, setCurrent] = useState(1);
    const [size, setSize] = useState(10);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    useImperativeHandle(ref, () => ({
        init,
    }));
    useEffect(() => {
        init();
    }, [current, size]);
    const columns = [
        {
            dataIndex: 'avatar',
            render: (text, record) => <Avatar src={record.sysCustomer.avatar} />,
        },
        {
            title: '客户',
            dataIndex: 'name',
            render: (text, record) => record.sysCustomer.name,
        },
        {
            title: '客户备注',
            dataIndex: 'remark',
        },
        {
            title: '客户备注电话',
            dataIndex: 'remarkMobiles',
        },
        {
            title: '客户描述',
            dataIndex: 'description',
        },
        {
            title: '客户交接状态',
            dataIndex: 'transferStatus',
            render: transferStatus =>
                transferStatus === '2' ? (
                    <Tag color="cyan">等待交接</Tag>
                ) : (
                    <Tag color="green">允许交接</Tag>
                ),
        },
    ];
    const rowSelection = {
        selectedRowKeys,
        onSelect: onSelect,
        onSelectAll: onSelectAll,
        // onChange: onSelectChange,
    };

    function init(isReload = false) {
        isReload && setSelectAll(false);
        setSelectedRowKeys(selectGives);
        setLoading(true);
        getFollowInfos(extId, {current, size}).then(res => {
            setData(res.data);
            setLoading(false);
        });
    }

    function onSelect(record, selected) {
        if (record.transferStatus === '2') {
            message.error('已处于交接状态');
            return;
        }
        let temp = [...selectedRowKeys];
        let select;
        if (selected) {
            temp.push(record.externalUserid);
            select = [...temp];
        } else select = temp.filter(item => item != record.externalUserid);
        setSelectedRowKeys(select);
        selectGive(!(select.length > 0), select);
    }

    function onSelectAll() {
        // 后台查询所有数据，并更新进rowkeys
        if (!selectAll) {
            getAllFollowInfos(extId).then(res => {
                let select = [];
                console.log(res);
                if (res.data.length > 0) {
                    res.data.forEach(
                        record =>
                            record.transferStatus !== '2' && select.push(record.externalUserid)
                    );
                    setSelectedRowKeys([...select]);
                    selectGive(false, select);
                }
            });
        } else {
            setSelectedRowKeys([]);
            selectGive(true, []);
        }
        setSelectAll(!selectAll);
    }

    function onShowSizeChange(current, pageSize) {
        setSize(pageSize);
        setCurrent(current);
    }

    function onChange(pageNumber) {
        console.log('change', selectedRowKeys);
        setCurrent(pageNumber);
    }

    return (
        <>
            <PageHeader title={'客户列表'} style={{overflowY: 'auto'}} />
            <Table
                loading={loading}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={data.records}
                rowKey={record => record.externalUserid}
                pagination={{
                    total: data.total,
                    showTotal: total => `共 ${total} 条记录`,
                    showSizeChanger: true,
                    onShowSizeChange: onShowSizeChange,
                    onChange: onChange,
                    current,
                    pageSize: size,
                }}
            />
        </>
    );
});

CustomerTable.displayName = 'CustomerTable';

export default CustomerTable;
